import React, { Component } from 'react';
import { TrackerUrlVariable, URLSelection } from '../../../../domain/tracker/variable/TrackerVariable';
import { RadioButton, RadioButtonChangeParams } from 'primereact/radiobutton';
import Icon from '../../../../icons/Icon';

class TrackerUrlVariableComponent extends Component<Props> {
  public render() {
    const { variable } = this.props;
    return (
      <div>
        {(['full', 'host', 'port', 'path', 'query', 'fragment', 'protocol'] as URLSelection[]).map((v: URLSelection) => (
          <div className={'flex items-center gap-x-2 py-2'} key={v}>
            <RadioButton inputId={v} name={v} value={v} onChange={this.onChangeType} checked={v == variable.selection} />
            <div className={'w-7 h-7 bg-[#EFF2FE] rounded-full flex items-center justify-center'}>
              <Icon icon={this.getIcon(v)} size={20} color={'#728EFF'} />
            </div>
            <div className={'flex flex-col'}>
              <span className={'text-f-black-2 text-[13px]'}>{this.getName(v)}</span>
              <span className={'text-f-black-3 text-[10px]'}>Description</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  private onChangeType = (event: RadioButtonChangeParams) => {
    const { variable, onChange } = this.props;
    variable.selection = event.value as URLSelection;
    onChange(variable);
  };

  private getName(text: URLSelection) {
    switch (text) {
      case 'full':
        return 'Full URL';
      case 'host':
        return 'Host';
      case 'port':
        return 'Port';
      case 'path':
        return 'Path';
      case 'query':
        return 'Query';
      case 'fragment':
        return 'Fragment';
      case 'protocol':
        return 'Protocol';
    }
  }

  private getIcon(v: URLSelection) {
    switch (v) {
      case 'fragment':
      case 'full':
        return 'tracker-url';
      case 'host':
        return 'tracker-host-name';
      case 'port':
        return 'tracker-port';
      case 'path':
        return 'tracker-path';
      case 'query':
        return 'tracker-query';
      case 'protocol':
        return 'tracker-protocol';
    }
  }
}

interface Props {
  variable: TrackerUrlVariable;
  onChange: (variable: TrackerUrlVariable) => void;
}

export default TrackerUrlVariableComponent;
